import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'
import { DateRange } from '@mui/lab/DateRangePicker'
import { IconButton } from '@mui/material'
import { IDateFilterVar } from 'context'
import { add, format, isToday } from 'date-fns'
import { YYYY_MM_DD } from 'utility/timeFormats'
import { DateQuickFilters } from '../helper'

export const LEFT = 'left'
export const RIGHT = 'right'

const DIRECTION_INCREMENT = {
  [RIGHT]: 1,
  [LEFT]: -1
}

interface IDateRangeArrow {
  direction: typeof LEFT | typeof RIGHT
  dateRange: DateRange<Date>
  selectedQuickFilter: DateQuickFilters
  changeDate: (selectedQuickFilter: DateQuickFilters, dateFilter: IDateFilterVar) => void
}

export const Arrow = ({
  direction,
  dateRange,
  selectedQuickFilter,
  changeDate
}: IDateRangeArrow) => {
  const arrowIcon = direction === RIGHT ? <KeyboardArrowRight /> : <KeyboardArrowLeft />

  const handleArrowPress = () => {
    const startDate = dateRange[0] ? new Date(dateRange[0]) : new Date()

    const nextDate = add(startDate, { days: DIRECTION_INCREMENT[direction] })
    const formattedNextDate = format(nextDate, YYYY_MM_DD)
    const nextValue = isToday(nextDate) ? DateQuickFilters.TODAY : DateQuickFilters.DEFINED

    changeDate(nextValue, {
      startDate: formattedNextDate,
      endDate: formattedNextDate
    })
  }

  const arrowEnabled =
    ((dateRange[0] && isToday(dateRange[0])) || selectedQuickFilter === DateQuickFilters.TODAY) &&
    direction === RIGHT

  return (
    <IconButton onClick={handleArrowPress} disabled={arrowEnabled} color="primary">
      {arrowIcon}
    </IconButton>
  )
}
